import { useEffect, useRef } from "react";

export default function useLiveMatchRefresh(onRefresh, busy) {
  const latest = useRef({ onRefresh, busy });
  latest.current = { onRefresh, busy };
  useEffect(() => {
    const refresh = () => {
      if (document.visibilityState !== "hidden" && !latest.current.busy) latest.current.onRefresh();
    };
    const timer = window.setInterval(refresh, 30000);
    document.addEventListener("visibilitychange", refresh);
    return () => { window.clearInterval(timer); document.removeEventListener("visibilitychange", refresh); };
  }, []);
}
